import * as z from 'zod'

import {PrimerComponentFaqGroupSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentFaqGroup'
import {PrimerComponentHeroSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentHero'
import {PrimerComponentSubnavSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentSubnav'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'

import {GenericContentSchema} from './generic-content'
import {GenericSectionSchema} from './generic-section'

const BrandContentSchema = z.lazy(() => z.array(z.union([GenericContentSchema, GenericSectionSchema])))

export type BrandContentSchemaType = z.infer<typeof BrandContentSchema>

export const TemplateBrandHeroSchema = z.lazy(() =>
  z.union([GenericContentSchema, GenericSectionSchema, PrimerComponentHeroSchema]),
)

export type TemplateBrandHero = z.infer<typeof TemplateBrandHeroSchema>

export const TemplateBrandSchema = buildEntrySchemaFor('templateBrand', {
  fields: z.lazy(() =>
    z.object({
      subnav: safeOptional(PrimerComponentSubnavSchema),
      hero: safeOptional(TemplateBrandHeroSchema),
      content: BrandContentSchema,
      faq: safeOptional(PrimerComponentFaqGroupSchema),
    }),
  ),
})

export type TemplateBrand = z.infer<typeof TemplateBrandSchema>
